import { styled } from '@vebox/etui-system';
import '../utilities/responsive.js';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement, cloneElement } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';
import Row from '../Container/Row.js';
import '../Container/config.js';
import Col from '../Container/Col.js';
import '../H4/H4.js';
import 'react-modal';
import { M as Modal$1 } from '../Modal-5d30452a.js';
import ModalHeader from './ModalHeader.js';

const _excluded = ["theme"];
const ModalContentDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    p: `${theme.spacing.md}px`,
    overflow: 'auto'
  }, props);
})`
  &:before,
  &:after {
    clear: both;
    display: table;
    content: '';
    line-height: 0;
  }

  flex: 1 1 auto;
`;

const _excluded$1 = ["theme"];
const ModalActionsDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2({
    display: 'block',
    p: `${theme.spacing.xs}px ${theme.spacing.md}px`
  }, props);
})`
  ::after {
    content: '';
    clear: both;
    display: table;
  }
`;

const _excluded$2 = ["styles", "shouldCloseOnOverlayClick", "actions", "actionButtons", "animationTiming", "header", "isOpen", "onClose", "style", "onAfterOpen", "fullPageSize", "appElement", "parentSelector"];
function Modal(_ref) {
  let {
      styles = {},
      shouldCloseOnOverlayClick = true,
      actions,
      actionButtons,
      animationTiming,
      header,
      isOpen,
      onClose,
      style,
      // react-modal API
      onAfterOpen,
      fullPageSize,
      appElement,
      parentSelector
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/createElement(Modal$1, {
    isOpen: isOpen,
    onRequestClose: onClose,
    animationTiming: animationTiming,
    onAfterOpen: onAfterOpen,
    fullPageSize: fullPageSize,
    appElement: appElement,
    style: style,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    parentSelector: parentSelector
  }, header && /*#__PURE__*/cloneElement(header, {
    onClose
  }), /*#__PURE__*/createElement(ModalContentDiv, styles.contentContainer, props.children), actions && /*#__PURE__*/createElement(ModalActionsDiv, styles.actionsContainer, actions), actionButtons && /*#__PURE__*/createElement(ModalActionsDiv, styles.actionsContainer, /*#__PURE__*/createElement(Row, {
    spacingSize: "xxs"
  }, actionButtons.map((buttonProps, i) => /*#__PURE__*/createElement(Col, {
    key: i,
    xs: 12 / actionButtons.length,
    spacingSize: "xxs"
  }, /*#__PURE__*/createElement(Button, _extends({
    block: true
  }, buttonProps)))))));
}
Modal.Header = ModalHeader;

export default Modal;
